import ExternalLinkRebrand from "./ExternalLinkRebrand"

export default ExternalLinkRebrand
